import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactECharts from "echarts-for-react";
import styles from "Components/Dashboard/dashboard.module.scss";
import { Spin } from "antd";
import { useAppSelector, useAppDispatch } from "store/hook";
import { getOption, ChartClick } from "../utils";
import { Label, ChartContainer, DashCard } from "./Shared";

import { useDeviceStatus } from "Components/Dashboard/queries";
import { useGetSchemeList } from "Components/Management/queries";

/*  FlowNumber: 1、顯示 IoT 流量數據的 Dashboard 卡片。
                2、提供點擊事件以進一步查看詳細數據。
                3、根據使用者的權限動態調整顯示樣式和點擊事件。
*/
const FlowNumber = () => {
  const [FlowsNum, setFlowsNum] = useState<any | number>(undefined);
  const { loginCid, stateCid, level, isLogin } = useAppSelector((state) => state.global);
  const { data: userScheme } = useGetSchemeList(stateCid, loginCid, level, isLogin);
  const { data: deviceStatus, isLoading, isFetching } = useDeviceStatus(level, stateCid, loginCid, isLogin);

  const loading = isLoading || isFetching;

  const disp = useAppDispatch();
  const navigate = useNavigate();

  const onChartClick = () => {
    // 檢查用戶是否有查看流量數據的權限，或者是否是 super_super 且 stateCid 為空
    if (!(userScheme?.permission_viewFlowData || (level === "super_super" && stateCid === ""))) {
      // 如果沒有，退出函數
      return;
    }
    // 如果用戶具有所需權限，導航到 "./iotguage" 路徑
    navigate("./iotguage");
  };

  // 處理從 API 獲取的裝置狀態數據，計算 IoT 流量的總數，並更新 FlowsNum 狀態。
  useEffect(() => {
    // 將請求到的資料做資料整理、把device_status obj flows number > 0 資料回傳
    // 並將大於 0 的資料 用 reduce函數 將陣列 大於0的資料 數量加總 保存到 useState
    if (deviceStatus?.response) {
      let RouterwithFlowNum = deviceStatus.response.device_status.filter(
        (item: any) => item.obj?.status?.flows?.number > 0
      );
      // FlowsNum 狀態，用於保存 IoT 流量數據。
      let FlowsNum = RouterwithFlowNum.map((item: any) => item.obj?.status?.flows?.number);
      // 將 FlowsNum 資料比數加總起來
      FlowsNum = FlowsNum.reduce((a: number, b: number) => a + b, 0);
      setFlowsNum(FlowsNum);
    } else {
      setFlowsNum(undefined);
    }
  }, [deviceStatus]);

  return (
    // Flow Number 圖表卡片
    <DashCard
      title={"IoTFlow"}
      bodyStyle={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {/* 載入中時顯示 Spin 載入動畫 */}
      {loading ? (
        <>
          <Spin className={styles.RouterWrapper} />
        </>
      ) : (
        <>
          <div
            className={styles.RouterWrapper}
            style={
              userScheme?.permission_viewFlowData || (level === "super_super" && stateCid === "")
                ? { cursor: "pointer" }
                : {}
            }
            onClick={() => onChartClick()}
          >
            <h2>{FlowsNum}</h2>
          </div>
        </>
      )}
    </DashCard>
  );
};

export default FlowNumber;
